
import React, { useState } from 'react';
// import { BusinessDetails } from '../../addBusinessModal/types'; // No longer needed directly
import { useBusinessFormContext } from '@/context/BusinessFormContext';
import {
  BasicInfoFormSection,
  AddressFormSection,
  IndustryFormSection,
  UserDetailsFormSection
} from './sections';

// Props for FormSections might become empty or very minimal
interface FormSectionsProps {
  // Props that CANNOT be derived from context, if any.
  // For now, assuming all necessary props will come from context.
}

const FormSections: React.FC<FormSectionsProps> = (props) => {
  const {
    // businessDetails, // from context
    // handleInputChange, // from context
    // handleSelectChange, // from context
    // selectedDate, // from context
    // calendarOpen, // from context
    // setCalendarOpen, // from context
    // handleDateSelect, // from context
    // basicInfoOpen, // from context
    // setBasicInfoOpen, // from context
    // addressOpen, // from context
    // setAddressOpen, // from context
    // industryOpen, // from context
    // setIndustryOpen, // from context
    // userDetailsOpen, // from context
    // setUserDetailsOpen, // from context
    // userEmail, // from context
    // handleEmailChange, // from context
    // termsAccepted, // from context
    // handleTermsChange, // from context
    // marketingOptIn, // from context
    // handleMarketingChange, // from context
    basicInfoComplete, // from context
    addressComplete, // from context
    industryComplete, // from context
    // userDetailsComplete, // from context (available, but UserDetailsFormSection takes it directly)
    // basicInfoEdited, // from context
    // addressEdited, // from context
    // industryEdited, // from context
    // basicInfoHasChanges, // from context
    // addressHasChanges, // from context
    // industryHasChanges, // from context
    // saveBasicInfo, // from context
    // saveAddress, // from context - used by AddressFormSection internally
    // saveIndustry, // from context
    // errors, // from context
  } = useBusinessFormContext();

  // isProcessingAddress and handleAddressSave are removed as AddressFormSection now handles its own state.

  // Show section 2 only if section 1 is complete
  const showAddressSection = basicInfoComplete;
  
  // Show section 3 only if sections 1 and 2 are complete
  const showIndustrySection = basicInfoComplete && addressComplete;
  
  // Show section 4 only if sections 1, 2, and 3 are complete
  const showUserDetailsSection = basicInfoComplete && addressComplete && industryComplete;

  // The individual sections (BasicInfoFormSection, etc.) will be refactored next
  // to consume the context directly, removing many of their props.
  // For now, they will break because their props are removed from FormSections.
  // This is an intermediate step.

  return (
    <div className="space-y-3 md:space-y-6">
      <BasicInfoFormSection
        // Props will be removed in next step when BasicInfoFormSection is refactored
        // For now, this will cause errors.
      />
      
      {showAddressSection && (
        <AddressFormSection
          // Props are removed as AddressFormSection now uses context
          // and manages its own save/processing logic internally.
        />
      )}
      
      {showIndustrySection && (
        <IndustryFormSection
          // Props will be removed
        />
      )}
      
      {showUserDetailsSection && (
        <UserDetailsFormSection
          // Props will be removed
        />
      )}
    </div>
  );
};

export default FormSections;
